// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9f6b572","749":"4b7aa6dc","903":"047d7e96","934":"46a3b090"}[chunkId] + ".chunk.js";
};